const stats = [
  { value: "24/7", label: "User Support" },
];

const values = [
  {
    icon: "ri-shield-check-line",
    title: "Security First",
    desc: "Every feature is built around protecting user data and ensuring privacy at the system level.",
  },
  {
    icon: "ri-speed-up-line",
    title: "Performance",
    desc: "We obsess over speed and efficiency, ensuring our apps run flawlessly on any iOS device.",
  },
  {
    icon: "ri-user-heart-line",
    title: "User-Centric",
    desc: "Clean, intuitive interfaces that feel native to iOS — designed to be used daily without friction.",
  },
  {
    icon: "ri-code-s-slash-line",
    title: "Expert Engineering",
    desc: "Our team of seasoned iOS developers uses modern Swift development practices and Apple-native frameworks.",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-[#f8f8f6] py-32 px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center mb-24">
          {/* Left: Text */}
          <div>
            <span className="inline-block text-[#0d9488] text-xs tracking-[4px] uppercase font-medium mb-5">
              Who We Are
            </span>
            <h2 className="text-4xl md:text-5xl font-light text-[#111218] leading-tight mb-6">
              A team driven by{" "}
              <span className="font-semibold">precision</span> and{" "}
              <span className="font-semibold">purpose</span>
            </h2>
            <p className="text-[#4b5563] text-base leading-relaxed mb-5">
              <strong>MELA OOD</strong> is a specialized iOS development company dedicated to creating high-quality mobile applications. We focus on two core product categories: privacy through VPN technology, and device health through intelligent cleaning tools.
            </p>
            <p className="text-[#4b5563] text-base leading-relaxed">
              Our team combines deep iOS expertise with a relentless focus on user satisfaction — delivering apps that are powerful under the hood, yet effortless to use in daily life.
            </p>
          </div>

          {/* Right: Image */}
          <div className="relative rounded-2xl overflow-hidden h-80">
            <img
              src="https://public.readdy.ai/ai/img_res/8e1e20a954f659a4029b6735b2a4c113.jpg"
              alt="MELA OOD workspace"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0f1117]/30 to-transparent" />
          </div>
        </div>

        {/* Stats */}
        <div className="mb-24">
          <div className="inline-flex items-center gap-4 bg-white rounded-xl px-8 py-5 border border-[#e5e7eb]">
            <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-[#0d9488]/10">
              <i className="ri-customer-service-2-line text-[#0d9488] text-xl" />
            </div>
            <div>
              <div className="text-2xl font-bold text-[#111218]">24/7</div>
              <div className="text-sm text-[#6b7280]">User Support</div>
            </div>
          </div>
        </div>

        {/* Values */}
        <div>
          <div className="text-center mb-12">
            <span className="inline-block text-[#0d9488] text-xs tracking-[4px] uppercase font-medium mb-3">
              Our Values
            </span>
            <h3 className="text-3xl font-light text-[#111218]">
              What guides our <span className="font-semibold">development process</span>
            </h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((v) => (
              <div
                key={v.title}
                className="bg-white rounded-xl p-6 border border-[#e5e7eb] hover:border-[#2dd4bf]/50 transition-all duration-300 group"
              >
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-[#0d9488]/10 mb-4 group-hover:bg-[#0d9488]/20 transition-colors duration-300">
                  <i className={`${v.icon} text-[#0d9488] text-xl`} />
                </div>
                <h4 className="text-[#111218] font-semibold text-base mb-2">{v.title}</h4>
                <p className="text-[#6b7280] text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
